export const getUrlParam = (param: string) =>
  new URLSearchParams(window.location.search).get(param);

export const getParamRefresh = () => getUrlParam("refresh");
